import { ActionTypes } from "../constants/action-types"
//https://www.youtube.com/watch?v=0W6i5LYKCSI

/*const initialState = {
    povrchy: [
        {
            ID: 1,
            publicID: 'P001',
            nazev: 'ŽULOVÁ DLAŽBA VELKÁ KOSTKA 16C Pražský normál - nová - I (alt. použitá ale splňující výrobní parametry)',
            vzorek1: 'misc-dummy/pov_1_1.png',
            vzorek2: 'misc-dummy/pov_1_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '1', KS2: '1', KS3: '2', BSE: '4', BSI: '4', PRK: '4' }],
            podminka: 'KS3 - na doplňkové plochy a pouze ze závažných důvodů (jinak doporučeno používat Nový pražský normál) BSI-E/PARK - používat jiné alternativy, pokud je žádoucí kámen (toto je příliš vzácný materiál)',
            popis: 'Žulová dlažba z ručně opracovaných velkých kostek 16C "Pražský normál" - nová (I kategorie) - (alt. použitá ale splňující výrobní parametry)',
            vyskaNaslapneVrstvy: '160mm'
        },
        {
            ID: 2,
            publicID: 'P002',
            nazev: 'ŽULOVÁ DLAŽBA VELKÁ KOSTKA - 16C "Pražský normál" recyklovaná opotřebovaná mírně - II',
            vzorek1: 'misc-dummy/pov_2_1.png',
            vzorek2: 'misc-dummy/pov_2_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '2', KS2: '3', KS3: '3', BSE: '4', BSI: '4', PRK: '3' }],
            podminka: 'pouze tam, kde se nepředpokládá pravidelný pěší a cyklistický pohyb PARK - doporučené jiné alternativy, pokud nutno kámen BSI-E/KS3 - nepřípustné z důvodu bariérovosti a špatného komfortu',
            popis: 'Žulová dlažba z ručně opracovaných velkých kostek 16C "Pražský normál" - recyklovaná - mírně opotřebovaná (II kategorie) - nově položená a vyrovnaná, s pečlivě přetěsněnou spárou',
            vyskaNaslapneVrstvy: '160mm'
        },
        {
            ID: 3,
            publicID: 'P003',
            nazev: 'ŽULOVÁ DLAŽBA VELKÁ KOSTKA - 16C "Pražský normál" recyklovaná opotřebovaná běžně až hodně III-IV',
            vzorek1: 'misc-dummy/pov_3_1.png',
            vzorek2: 'misc-dummy/pov_3_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '3', KS3: '3', BSE: '4', BSI: '4', PRK: '3' }],
            podminka: 'KS1-2 pouze tam, kde se nepředpokládá pravidelný pěší a cyklistický pohyb PARK - doporučené jiné alternativy, pokud nutno kámen BSI-E/KS3 - nepřípustné z důvodu bariérovosti a špatného komfortu',
            popis: 'Žulová dlažba z ručně opracovaných velkých kostek 16C "Pražský normál" - recyklovaná - běžně (až hodně) opotřebovaná (III-IV kategorie) - oštípaná, vyboulená, zakulacená, ohlazená,',
            vyskaNaslapneVrstvy: '160mm'
        },
        {
            ID: 4,
            publicID: 'P004',
            nazev: 'KŘEMENCOVÁ DLAŽBA (ŘEVNICKÁ) VELKÁ KOSTKA recyklovaná, opotřebovaná běžně až hodně III-IV',
            vzorek1: 'misc-dummy/pov_4_1.png',
            vzorek2: 'misc-dummy/pov_4_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '3', KS3: '4', BSE: '3', BSI: '3', PRK: '4' }],
            podminka: 'KS1-2 zachovat tam kde je (doplnit a nahradit zničené kostky) povrch nevhodný na frekventovaná místa (bariérový povrch) BSI-E/PRK - nezřizovat nově - pouze zachovat tam, kde je v současnosti a spoltvoří identitu místa',
            popis: 'Křemencová dlažba z ručně opraco-vaných velkých kostek Dlažba recyk-lovaná - běžně (až hodně) opotřebovaná (II-IV kategorie) - oštípaná, vyboulená, zakulacená, ohlazená povrch zlatavý speci¶cky pražský, vzácný a nedos-tupný; nekomfortní, hlučný, bariérový, památkově chráněný',
            vyskaNaslapneVrstvy: '160mm'
        },
        {
            ID: 5,
            publicID: 'P005',
            nazev: 'ŽULOVÁ DLAŽBA VELKÁ, KOSTKA 16/16- 30/16 Nový Pražský normál',
            vzorek1: 'misc-dummy/pov_5_1.png',
            vzorek2: 'misc-dummy/pov_5_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '2', KS2: '1', KS3: '1', BSE: '3', BSI: '3', PRK: '3' }],
            podminka: 'KS1 - na místa "kamenné dlažby s úpravou pro hladký pojezd - dle koncepce živičných a dlážděných povrchů PPR" a na autorsky navrhovaná významná prostranství BSE-I/PARK - doplňkově (v odůvodněných příp.)',
            popis: 'Žulová kostka velká 16/16-30/16 2. třída (ČSN EN 1342) strojně opracovaná - hrubě štokovaný tryskaný líc, řezané styčné plochy. tolerance důlků a hrbolků max +/- 3mm, max toler. půd. rozm. +/- 7 mm, max spára styč. ploch 15 mm těsněná drtí fr. 2/4. Přijatelně komfortní, kvalitní detail i materiál. průmyslově vyrobitelný',
            vyskaNaslapneVrstvy: '160mm'
        }
    ],
    doplnky: [
        {
            ID: 1,
            publicID: 'D001-V',
            nazev: 'ŽULOVÝ OBRUBNÍK OP1 PŘÍMÝ POUŽITÝ, SE ZÁMKEM opracovaný původní ruční technologií',
            vzorek1: 'misc-dummy/dop_1_1.png',
            vzorek2: 'misc-dummy/dop_1_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '1', KS2: '2', KS3: '3', BSE: '0', BSI: '0', PARK: '0' }],
            klasifikace: 'výrobek',
            popis: '32x24x80-200 cm, štípaný blok, horní líc a boční líc opracovaný ručně pemrlicí, zámek',
            modifVar: '-N/A-',
            poznPodm: '-N/A-',
            dostupnost: '-N/A-'
        },
        {
            ID: 2,
            publicID: 'D002-V',
            nazev: 'ŽULOVÝ OBRUBNÍK OP1 PŘÍMÝ NOVÝ, BEZ ZÁMKU řezaný tryskaný (strojní opracování)',
            vzorek1: 'misc-dummy/dop_2_1.png',
            vzorek2: 'misc-dummy/dop_2_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '2', KS3: '1', BSE: '0', BSI: '0', PARK: '0' }],
            klasifikace: 'vyrobek',
            popis: '32x24x80-120 cm, řezaný blok, otryskaný, řezaný zámek',
            modifVar: '-N/A-',
            poznPodm: '-N/A-',
            dostupnost: '-N/A-'
        },
        {
            ID: 3,
            publicID: 'D003-V',
            nazev: 'ŽULOVÝ OBRUBNÍK OP1 RADIUS 50 CM - detail nároží mysu',
            vzorek1: 'misc-dummy/dop_3_1.png',
            vzorek2: 'misc-dummy/dop_3_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '1', KS3: '1', BSE: '0', BSI: '0', PARK: '0' }],
            klasifikace: 'DETAIL',
            popis: '-N/A-',
            modifVar: '-N/A-',
            poznPodm: '-N/A-',
            dostupnost: '-N/A-'
        },
        {
            ID: 4,
            publicID: 'D004-D',
            nazev: 'DETAIL - STYK ručně opracovanéh OP1(2) SE ZÁMKEM A řezanéh novéh OP1(2) BEZ ZÁMKU',
            vzorek1: 'misc-dummy/dop_4_1.png',
            vzorek2: 'misc-dummy/dop_4_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '1', KS3: '1', BSE: '0', BSI: '0', PARK: '0' }],
            klasifikace: 'DETAIL',
            popis: 'Styk použitého ručně opracovaného obrubníku OP1 se zámkem a nového trojně opracovaného OP1 bez zámku',
            modifVar: '-N/A-',
            poznPodm: 'provádí se rovným zaříznutím použitého ručně opracovaného OP1 při jednom z konců a přisazením nového řezaného OP1. Podmínka KS1: nepříp. v místech s dochovanými hist. povrchy (štíp. mozaik slivenec a řevnická dlažba)',
            dostupnost: '-N/A-'
        },
        {
            ID: 5,
            publicID: 'D005-V',
            nazev: 'ŽULOVÝ OBRUBNÍK OP2 PŘÍMÝ POUŽITÝ, SE ZÁMKEM opracovaný původní ruční technologií',
            vzorek1: 'misc-dummy/dop_5_1.png',
            vzorek2: 'misc-dummy/dop_5_2.png',
            info: 'pro PS',
            rodinaPovrchu: [{ KS1: '3', KS2: '1', KS3: '1', BSE: '0', BSI: '0', PARK: '0' }],
            klasifikace: 'DETAIL',
            popis: '30x20x80-120cm, řezaný blok, otryskaný, koncerovné',
            modifVar: 'NOVÝ NEBO POUŽITÝ',
            poznPodm: '-N/A-',
            dostupnost: '-N/A-'
        }
    ],
    vybaveni: [
        {
            ID: 1,
            publicID: 'V01PR',
            nazev: 'LAVIČKA PRAŽSKÁ čtyřnohá - základní sada + stůl',
            rod: 'PRG',
            vzorek1: 'misc-dummy/vyb_1_1.png',
            vzorek2: 'misc-dummy/vyb_1_2.png',
            info: 'veřejné',
            modelModifikace: 'set - s opěrákem - s op. a područkami - bez opěráku - vyšší seniorská (?) - stůl',
            popis: 'nosná konstrukce z hliníkové slitiny, práškový vypalovaný lak RAL 7021 Latě z odolného masivního dřeva opatřeného přírodním olejovým nátěrem',
            pozadavkyDesign: 'celá designová řada: - Varianta bez opěráku - Varianta s opěrákem a područkami - Zvýšená varianta - seniorská (?) - Stůl - konstrukční stabilita a tuhost - konstrukční ochrana dřeva (nikde nestojí voda)'
        },
        {
            ID: 2,
            publicID: 'V02PR',
            nazev: 'LAVIČKA PRAŽSKÁ dvounohá - základní sada + stůl',
            rod: 'PRG',
            vzorek1: 'misc-dummy/vyb_2_1.png',
            vzorek2: 'misc-dummy/vyb_2_2.png',
            info: 'veřejné',
            modelModifikace: 'set - s opěrákem - s op. a područkami - bez opěráku - vyšší seniorská (?) - stůl',
            popis: 'nosná konstrukce z hliníkové slitiny, kotvená šrouby do (betonových) patek pod úrovní terénu, práškový vypalovaný lak RAL 7021 Latě z odolného masivního dřeva opatřeného přírodním olejovým nátěrem',
            pozadavkyDesign: 'celá designová řada: - Varianta bez opěráku - Varianta s opěrákem a područkami - Zvýšená varianta - seniorská (?) - Stůl - konstrukční stabilita a tuhost - konstrukční ochrana dřeva (nikde nestojí voda)'
        },
        {
            ID: 3,
            publicID: 'V03MO',
            nazev: 'LAVIČKA PRAŽSKÁ čtyřnohá - základní sada + stůl',
            rod: 'MOD',
            vzorek1: 'misc-dummy/vyb_3_1.png',
            vzorek2: 'misc-dummy/vyb_3_2.png',
            info: 'pro PS',
            modelModifikace: 'set - s opěrákem - s op. a područkami - bez opěráku - vyšší seniorská - kolem stromu - stůl',
            popis: 'kovová nosná kce latě sedáku z tepelně málo vodivé hmoty přírodního původu (dřevo, kompozit na přírodní bázi) kotvená do podkladu šrouby nebo skrytě do základové patky (zabetonováním, nebo šrouby)',
            pozadavkyDesign: 'celá designová řada: - Varianta bez opěráku - Varianta s opěrákem a područkami - Varianta "kolem stromu" - Zvýšená varianta - seniorská - Stůl - Model s dlouhou perspektivou ve výrobním programu - konstrukční ochrana dřeva (nikde nestojí voda)'
        },
        {
            ID: 4,
            publicID: 'V04OR',
            nazev: 'LAVIČKA KOVOVÁ LITÁ - ORN1 - základní sada',
            rod: 'MOD',
            vzorek1: 'misc-dummy/vyb_4_1.png',
            vzorek2: 'misc-dummy/vyb_4_2.png',
            info: 'pro PS',
            modelModifikace: 'set - s opěrákem - bez opěráku - vyšší seniorská',
            popis: 'kovová nosná kce latě sedáku a opěráku z tvrdého přírodního dřeva kotvená do podkladu šrouby nebo trny, nebo skrytě do zákl. patky',
            pozadavkyDesign: 'Plynulá křivka sedák opěrák vizuálně dominantní je laťování, ne nohy konstrukce z kovu litého do formy (možno i kombinace hlavních litých částí a doplňkových částí vyrobených jinak - lité části ale tvoří charakter konstrukce výrobku) Dřevo masivní přírodní Latě přečnívající - varianta sedák+opěrák - varianta bez opěráku'
        },
        {
            ID: 5,
            publicID: 'V05OR',
            nazev: 'LAVIČKA KOVOVÁ LITÁ - ORN2 - základní sada',
            rod: 'MOD',
            vzorek1: 'misc-dummy/vyb_5_1.png',
            vzorek2: 'misc-dummy/vyb_5_2.png',
            info: 'pro PS',
            modelModifikace: 'set - s opěrákem - bez opěráku - vyšší seniorská',
            popis: 'kovová nosná kce latě sedáku a opěráku z tvrdého přírodního dřeva kotvená do podkladu šrouby nebo trny',
            pozadavkyDesign: 'Sedák + opěrák - v základu s područkami Charakter utváří kovové i dřevěné prvky rovnoměrně kovové prvky z litiny dřevo masivní, přírodní - varianta sedák+opěrák - varianta bez opěráku'
        }
    ],
    fullPovrch: {
        ID: 1,
        publicID: 'P001',
        nazev: 'ŽULOVÁ DLAŽBA VELKÁ KOSTKA 16C Pražský normál - nová - I (alt. použitá ale splňující výrobní parametry)',
        vzorek1: 'misc-dummy/pov_1_1.png',
        vzorek2: 'misc-dummy/pov_1_2.png',
        info: 'pro PS',
        rodinaPovrchu: [{ KS1: '1', KS2: '1', KS3: '2', BSE: '4', BSI: '4', PRK: '4' }],
        podminka: 'KS3 - na doplňkové plochy a pouze ze závažných důvodů (jinak doporučeno používat Nový pražský normál) BSI-E/PARK - používat jiné alternativy, pokud je žádoucí kámen (toto je příliš vzácný materiál)',
        popis: 'Žulová dlažba z ručně opracovaných velkých kostek 16C "Pražský normál" - nová (I kategorie) - (alt. použitá ale splňující výrobní parametry)',
        vyskaNaslapneVrstvy: '160mm',
        zaklPovoleneFormaty: '16C, š/d/v 16/16- 28/16',
        pouziti: 'Vozovky - mimo zn. Cyklotrasy - parkovací pásy a zálivy',
        klad: 'řádková dlažba',
        poznamky: 'KOSTKA NESMÍ BÝT (příliš) OPOTŘEBENÁ - musí splňovat uvedenou ČSN MAP 2002 podle které byla vyrobena (alternativně ČSN EN 1342 (s podmínkou zajištění spáry styčných ploch max 15mm) a požadavek na protiskluz. Nedoporučeno pro vozovky s cyklistickým provozem, v krátkých úsecích výjimečně přípustné',
        modifVar: '-N/A-',
        dostupnost: 'STÁVAJÍCÍ NEOPOTŘEBENÝ MATERIÁL JE REÁLNĚ NEDOSTUPNÝ - vyskytuje se pouze na málo místech s malou dopravní zátěží nebo možná někde pod asfaltem. NOVÝ MATERIÁL JE KLASICKOU RUČNÍ TECHNOLOGIÍ OPRACOVÁNÍ VYROBITELNÝ POUZE ZA ASTRONOMICKÉ PENÍZE (zkušení kameníci jsou nedostupní) (LOMY EXISTUJÍ)',
        cenHladKrytu: '-N/A-'
    },
    fullDoplnek: {
        ID: 1,
        publicID: 'D001-V',
        nazev: 'ŽULOVÝ OBRUBNÍK OP1 PŘÍMÝ POUŽITÝ, SE ZÁMKEM opracovaný původní ruční technologií',
        vzorek1: 'misc-dummy/dop_1_1.png',
        vzorek2: 'misc-dummy/dop_1_2.png',
        info: 'pro PS',
        rodinaPovrchu: [{ KS1: '1', KS2: '2', KS3: '3', BSE: '0', BSI: '0', PARK: '0' }],
        klasifikace: 'výrobek',
        popis: '32x24x80-200 cm, štípaný blok, horní líc a boční líc opracovaný ručně pemrlicí, zámek',
        modifVar: '-N/A-',
        poznPodm: '-N/A-',
        dostupnost: '-N/A-'
    },
    fullVybaveni: {
        ID: 1,
        publicID: 'V01PR',
        nazev: 'LAVIČKA PRAŽSKÁ čtyřnohá - základní sada + stůl',
        rod: 'PRG',
        vzorek1: 'misc-dummy/vyb_1_1.png',
        vzorek2: 'misc-dummy/vyb_1_2.png',
        info: 'veřejné',
        modelModifikace: 'set - s opěrákem - s op. a područkami - bez opěráku - vyšší seniorská (?) - stůl',
        popis: 'nosná konstrukce z hliníkové slitiny, práškový vypalovaný lak RAL 7021 Latě z odolného masivního dřeva opatřeného přírodním olejovým nátěrem',
        pozadavkyDesign: 'celá designová řada: - Varianta bez opěráku - Varianta s opěrákem a područkami - Zvýšená varianta - seniorská (?) - Stůl - konstrukční stabilita a tuhost - konstrukční ochrana dřeva (nikde nestojí voda)',
        pozadavkyErgonomie: '-N/A-',
        pozadavkyMaterial: '-N/A-',
        pozadavkyServis: '-N/A-',
        dostupnostNaTrhu: '-N/A-',
        certifikat: '-N/A-',
        cenovaHladina: '-N/A-'
    }
};*/

/*const initialState = {
    povrchy: [],
    doplnky: [],
    vybaveni: [],
    fullPovrch: {
        ID: 1,
        publicID: 'P001',
        nazev: 'ŽULOVÁ DLAŽBA VELKÁ KOSTKA 16C Pražský normál - nová - I (alt. použitá ale splňující výrobní parametry)',
        vzorek1: 'foto1.png',
        vzorek2: 'foto2.png',
        info: 'pro PS',
        rodinaPovrchu: [{ KS1: '1', KS2: '1', KS3: '2', BSE: '5', BSI: '5', PRK: '5' }],
        podminka: 'KS3 - na doplňkové plochy a pouze ze závažných důvodů (jinak doporučeno používat Nový pražský normál) BSI-E/PARK - používat jiné alternativy, pokud je žádoucí kámen (toto je příliš vzácný materiál)',
        popis: 'Žulová dlažba z ručně opracovaných velkých kostek 16C "Pražský normál" - nová (I kategorie) - (alt. použitá ale splňující výrobní parametry)',
        vyskaNaslapneVrstvy: '160mm',
        zaklPovoleneFormaty: '16C, š/d/v 16/16- 28/16',
        pouziti: 'Vozovky - mimo zn. Cyklotrasy - parkovací pásy a zálivy',
        klad: 'řádková dlažba',
        poznamky: 'KOSTKA NESMÍ BÝT (příliš) OPOTŘEBENÁ - musí splňovat uvedenou ČSN MAP 2002 podle které byla vyrobena (alternativně ČSN EN 1342 (s podmínkou zajištění spáry styčných ploch max 15mm) a požadavek na protiskluz. Nedoporučeno pro vozovky s cyklistickým provozem, v krátkých úsecích výjimečně přípustné',
        modifVar: '-empty-',
        dostupnost: 'STÁVAJÍCÍ NEOPOTŘEBENÝ MATERIÁL JE REÁLNĚ NEDOSTUPNÝ - vyskytuje se pouze na málo místech s malou dopravní zátěží nebo možná někde pod asfaltem. NOVÝ MATERIÁL JE KLASICKOU RUČNÍ TECHNOLOGIÍ OPRACOVÁNÍ VYROBITELNÝ POUZE ZA ASTRONOMICKÉ PENÍZE (zkušení kameníci jsou nedostupní) (LOMY EXISTUJÍ)',
        cenHladKrytu: '-empty-'
    },
    fullDoplnek: {
        ID: 1,
        publicID: 'D001-V',
        nazev: 'ŽULOVÝ OBRUBNÍK OP1 PŘÍMÝ POUŽITÝ, SE ZÁMKEM opracovaný původní ruční technologií',
        vzorek1: 'foto1.png',
        vzorek2: 'foto2.png',
        info: 'pro PS',
        rodinaPovrchu: [{ KS1: '1', KS2: '2', KS3: '4', BSE: '0', BSI: '0', PARK: '0' }],
        klasifikace: 'výrobek',
        popis: '32x24x80-200 cm, štípaný blok, horní líc a boční líc opracovaný ručně pemrlicí, zámek',
        modifVar: 'neuvedeno',
        poznPodm: 'neuvedeno',
        dostupnost: 'neuvedeno'
    },
    fullVybaveni: {
        ID: 1,
        publicID: 'V01PR',
        nazev: 'LAVIČKA PRAŽSKÁ čtyřnohá - základní sada + stůl',
        rod: 'PRG',
        vzorek1: 'foto1.png',
        vzorek2: 'foto2.png',
        info: 'veřejn',
        modelModifikace: 'set - s opěrákem - s op. a područkami - bez opěráku - vyšší seniorská (?) - stůl',
        popis: 'nosná konstrukce z hliníkové slitiny, práškový vypalovaný lak RAL 7021 Latě z odolného masivního dřeva opatřeného přírodním olejovým nátěrem',
        pozadavkyDesign: 'celá designová řada: - Varianta bez opěráku - Varianta s opěrákem a područkami - Zvýšená varianta - seniorská (?) - Stůl - konstrukční stabilita a tuhost - konstrukční ochrana dřeva (nikde nestojí voda)',
        pozadavkyErgonomie: 'asd',
        pozadavkyMaterial: 'asd',
        pozadavkyServis: 'asd',
        dostupnostNaTrhu: 'asd',
        certifikat: 'asd',
        cenovaHladina: 'asd'
    }
};*/

const initialState = {
    povrchy: [],
    doplnky: [],
    vybaveni: [],
    fullPovrch: null,
    fullDoplnek: null,
    fullVybaveni: null
}
export const prvkyReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_POVRCHY:
            return { ...state, povrchy: payload };
        case ActionTypes.SET_DOPLNKY:
            return { ...state, doplnky: payload };
        case ActionTypes.SET_VYBAVENI:
            return { ...state, vybaveni: payload };
            
        //single fullPrvek select-remove upon dismounting switch here
        //// 
        case ActionTypes.SELECTED_POVRCH:
            return { ...state, fullPovrch: payload };
        case ActionTypes.REMOVE_SELECTED_POVRCH:
            return { ...state, fullPovrch: {} };
        ////
        case ActionTypes.SELECTED_DOPLNEK:
            return { ...state, fullDoplnek: payload };
        case ActionTypes.REMOVE_SELECTED_DOPLNEK:
            return { ...state, fullDoplnek: {} };
        ////
        case ActionTypes.SELECTED_VYBAVENI:
            return { ...state, fullVybaveni: payload };
        case ActionTypes.REMOVE_SELECTED_VYBAVENI:
            return { ...state, fullVybaveni: {} };
        ////
        default:
            return state
    }
}